export default {
    footer: "Hashworth Psychology's Diversity Clinic Est. 2021",
    acknowledgement: "Hashworth Psychology's Diversity Clinic acknowledges and pays respect to the Traditional Custodians of the Dharawal Country, the land on which we meet"
}